export const StockMeter = ({ product, compact = false, testId = "stock-meter" }) => {
  if (product.stock == null) return null;
  const { stock, remaining } = product;
  const pct = Math.max(0, Math.min(100, Math.round((remaining / stock) * 100)));
  const low = remaining > 0 && pct <= 20;
  const out = remaining <= 0;
  return (
    <div data-testid={testId} className={compact ? "mt-2" : "mt-4"}>
      <div className="flex items-center justify-between gap-3">
        <span className={`font-mono-d ${compact ? "text-[9px]" : "text-[10px]"} uppercase tracking-[0.2em] ${out || low ? "text-[#ff2a85]" : "text-[#5f5e5a]"}`}>
          {out ? "Sold out" : `${remaining.toLocaleString()} of ${stock.toLocaleString()} left`}
        </span>
        {!out && !compact && <span className="font-mono-d text-[9px] uppercase tracking-[0.15em] text-[#5f5e5a]">{stock - remaining} claimed</span>}
      </div>
      <div className={`${compact ? "mt-1 h-[3px]" : "mt-2 h-1"} w-full rounded-full bg-[#0a0a0b]/10 overflow-hidden`}>
        <div className={`h-full rounded-full transition-[width] duration-700 ${out || low ? "bg-[#ff2a85]" : "bg-[#0a0a0b]"}`} style={{ width: `${pct}%` }} />
      </div>
    </div>
  );
};
